module.exports = __webpack_public_path__ + "img/full04.af8f7f1d.png";